export default __webpack_public_path__ + "static/media/45_BottomRightSquares_ZoomOut.3f80553b.mp4";